<script setup lang="ts">
import { computed } from 'vue';

import AccountAvatar from '@/components/UI/avatar/AccountAvatar.vue';
import SmartAppBarAccountMenuVList from '@/components/vLists/SmartAppBarAccountMenuVList.vue';
import { useUserStore } from '@/stores/useUserStore';
import { accountList } from '@/constants/menuLists';

const userStore = useUserStore();

const user = computed(() => userStore.user);
</script>

<template>
  <v-menu
    eager
    :class="$style.accountBarVMenu"
    :content-class="$style.content"
    data-testid="accountBarVMenu"
  >
    <template #activator="{ props: menuProps }">
      <v-list-item
        :ripple="false"
        :class="$style.avatarListItem"
        v-bind="menuProps"
      >
        <AccountAvatar
          :size="40"
          color="purple"
          background="purple"
          :class="$style.avatar"
          :text="user && user.username ? user.username[0] : ''"
          :image-u-r-l="user.avatar"
        />
        <span :class="$style.username" data-testid="accountBarVMenu-username">
          {{ user.username }}
        </span>
        <v-icon icon="mdi-chevron-down"></v-icon>
      </v-list-item>
    </template>
    <SmartAppBarAccountMenuVList :list="accountList" />
  </v-menu>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.accountBarVMenu {
}
  .avatarListItem {
    height: 100%;
    display: flex;
    align-items: center;
    color: colors.$color-brand-800;

    &:hover {
      color: colors.$color-brand-400;
    }
    &:active {
      color: colors.$color-brand-300;
    }
    &[aria-expanded=true] {
      color: colors.$color-brand-300;
    }

    :global {
      .v-list-item__overlay {
        display: none;
      }
    }
  }
    .avatar {
      box-shadow: none;
    }
    .username {
      margin-left: 10px;
      margin-right: 5px;
    }

.content {
  right: variables.$pageMarginX;
  left: auto !important;
}
</style>
